export function isUrl(selectorString) {
    return /^(http(s?):\/\/|\/)/.test(selectorString);
}

